import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./WorkForUsPage.module.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";

export default function WorkForUsPage() {
	const { i18n } = useTranslation();
	const [form, setForm] = useState({
		name: "",
		email: "",
		message: "",
	});

	const BackgroundImg = IMAGES["MainBackground.png"];

	const handleChange = (e) => {
		const { name, value } = e.target;
		setForm((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	return (
		<div
			className={styles["work-for-us-container"]}
			style={{ backgroundImage: `url(${BackgroundImg})` }}
		>
			<div className={styles["work-for-us-card"]}>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						marginBottom: "20px",
					}}
				>
					<h2 className={styles["work-for-us-card-title"]}>
						{getTranslation(i18n, "workForUsPage.title")}
					</h2>
				</div>
				<p className={styles["subtitle"]}>
					{getTranslation(i18n, "workForUsPage.subtitle")}
				</p>
				<form
					onSubmit={handleSubmit}
					className={styles["animated-form"]}
				>
					<label
						className={`${styles["form-label"]} ${styles["form-field-1"]}`}
					>
						{getTranslation(i18n, "workForUsPage.form.name")}
						<input
							className={`${styles["form-input"]} ${styles["animated-input"]}`}
							type="text"
							name="name"
							placeholder={getTranslation(
								i18n,
								"workForUsPage.form.namePlaceholder"
							)}
							value={form.name}
							onChange={handleChange}
							required
						/>
					</label>

					<label
						className={`${styles["form-label"]} ${styles["form-field-2"]}`}
					>
						{getTranslation(i18n, "workForUsPage.form.email")}
						<input
							className={`${styles["form-input"]} ${styles["animated-input"]}`}
							type="email"
							name="email"
							placeholder={getTranslation(
								i18n,
								"workForUsPage.form.emailPlaceholder"
							)}
							value={form.email}
							onChange={handleChange}
							required
						/>
					</label>

					<label
						className={`${styles["form-label"]} ${styles["form-field-3"]}`}
					>
						{getTranslation(i18n, "workForUsPage.form.message")}
						<textarea
							className={`${styles["form-textarea"]} ${styles["animated-input"]}`}
							name="message"
							placeholder={getTranslation(
								i18n,
								"workForUsPage.form.messagePlaceholder"
							)}
							value={form.message}
							onChange={handleChange}
							required
						/>
					</label>

					<button
						type="submit"
						className={`${styles["form-button"]} ${styles["animated-submit-button"]} ${styles["form-field-4"]}`}
					>
						{getTranslation(
							i18n,
							"workForUsPage.form.submitButton"
						)}
					</button>
				</form>
			</div>
		</div>
	);
}
